// extracted by mini-css-extract-plugin
export default {"warningBlock":"styles_warningBlock__TC-a2","warningBlockIcon":"styles_warningBlockIcon__vKjSg","warningBlockText":"styles_warningBlockText__1Ur13"};